<template>
  <div class="toolbar">
    <div class="search">
      <div class="d-flex">
        <RexSelectV3
          :value="getSelectedCapabilityValue"
          @onChange="selectCapabilityOption"
          :showSearch="true"
          :filterOption="filterOption"
          :customStyle="{ width: '18.75rem' }"
          class="capability-dropdown dropdown-alertV2"
          id="search-select-capablity"
        >
          <template #default>
            <RexSelectOption
              v-for="(obj, i) in getAlertCapabilitiesList"
              :key="`${obj.value}-${i}`"
              :label="obj.label"
              :disabled="obj.disabled"
            >
              <div>
                {{ obj.label }}
                <BaseIcon
                  v-if="obj.icon"
                  class="showAIEnabledIcon"
                  :name="obj.icon"
                  width="1rem"
                  height="1rem"
                />
              </div>
            </RexSelectOption>
          </template>
        </RexSelectV3>
        <RexSelectV3
          v-if="
            getCurrentAlertCapability.label ===
            ALERT_CAPABILITY_TYPE.CLOUD_MONITORING
          "
          :value="currentVendor"
          :options="getAWSAlertCapabilitiesList"
          :customStyle="{ width: '18.75rem' }"
          @onChange="(item) => selectAWSCapabilityOption(item)"
          class="capability-dropdown dropdown-alertV2"
          id="search-select-capablity"
        />
        <RexSelectV3
          v-if="
            getCurrentAlertCapability.label ===
            ALERT_CAPABILITY_TYPE.CLOUD_MONITORING
          "
          :value="currentService"
          :options="getRDSAlertCapabilitiesList"
          :customStyle="{ width: '18.75rem' }"
          @onChange="(item) => selectRDSCapabilityOption(item)"
          class="capability-dropdown dropdown-alertV2"
          id="search-select-capablity"
        />
        <RexInfiniteScrollDropdown
          :showSearch="true"
          :value="getSelectedAppValue"
          :options="getAlertApplicationsList"
          :searchKeyword="searchAlertService"
          id="search-select-application"
          :loading="isLoading"
          :total="alertApplicationCount"
          :customStyle="{ width: '18.75rem' }"
          @onDropdownVisibleChange="onOpenSelectField"
          @onPopupScroll="scrollAlertServices"
          @onSearch="onSearchAlertService"
          @onChange="selectApplicationOption"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import { parseServiceObjFromApplication } from '@/utils/helper-function';
import { CAPABILITY_WSM } from '@/utils/constants';
import AlertsV2Utils from './alertsV2Utils.js';
import BuildConfig from '@/environment';
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
import { Capability } from '@/utils/enums/metricType';
import RexInfiniteScrollDropdown from '@/rex-components/RexInfiniteScrollDropdown.vue';
import { PAGE_SIZE_SCROLL } from '@/utils/constants';
import {
  AWS_ALERT_CAPABILITIES,
  RDS_ALERT_CAPABILITIES,
  ALERT_CAPABILITY_TYPE,
  ALERT_SUB_TYPES,
} from '@/components/AlertsV2/constants.js';
import { dbTypes } from '../Cloud/Dashboard/cloud.types.js';
import { RexSelectOption } from '@/rex-components/rex.comp.config';
import { AI_CAPABILITIES } from '@/components/AlertsV2/constants';
import { permissionTypes } from '@/router/constant';
import { usePermissions } from '@/hooks/usePermissions';

export default {
  name: 'HeaderAlertsV2',
  components: {
    RexSelectV3,
    RexSelectOption,
    RexInfiniteScrollDropdown,
  },
  data() {
    return {
      ALERT_CAPABILITY_TYPE,
      dbTypes,
      searchCapability: this.$t('searchCapability'),
      searchApplication: this.$t('searchService'),
      currentVendor: 'AWS',
      currentService: '',
      subTypeNameMapping: {
        ES: 'Elasticsearch',
        CB: 'Couchbase',
        MY: 'MySQL',
        MS: 'MsSQL',
        OR: 'Oracle',
        PG: 'Postgres',
        AR: 'ActiveMQ',
        KA: 'Kafka',
        MG: 'MongoDB',
      },
      cloudSubType: '',
      stylingAddChannel: {
        width: '6rem',
      },
      setAlertActiveCapabilty: false,
      isLoading: false,
      searchAlertService: '',
      currentPage: 1,
    };
  },

  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapGetters('globalState/app', ['getActiveCapabilities']),
    ...mapGetters('alertV2State/configure', [
      'getCurrentAlertCapability',
      'getAlertCapabilities',
      'getAlertApplications',
      'getCurrentAlertApplication',
    ]),
    ...mapState('alertV2State/configure', [
      'currentApplication',
      'currentCapability',
      'currentSubType',
      'alertApplicationCount',
      'serviceCurrentPage',
    ]),
    getAWSAlertCapabilitiesList() {
      return AWS_ALERT_CAPABILITIES;
    },
    getRDSAlertCapabilitiesList() {
      return RDS_ALERT_CAPABILITIES;
    },
    getSelectedAppValue() {
      return this.getCurrentAlertApplication
        ? this.getCurrentAlertApplication?.label
        : '';
    },
    getSelectedCapabilityValue() {
      return this.getCurrentAlertCapability
        ? this.getCurrentAlertCapability?.label
        : '';
    },
    getSearchServicePlaceholder() {
      if (this.currentCapability && this.currentCapability.key == 'LOG') {
        return 'searchSavedSearch';
      }
      return 'searchService';
    },
    getAlertApplicationsList() {
      let applications = this.getAlertApplications;

      if (Array.isArray(applications) && applications.length > 0) {
        applications.forEach((application) => {
          let service = parseServiceObjFromApplication(application);
          if (service && (service.type === 'D' || service.type === 'Q')) {
            application.label =
              this.subTypeNameMapping[service.sub] &&
              !application.label.includes('>')
                ? this.subTypeNameMapping[service.sub] +
                  ' > ' +
                  application.label
                : application.label;
          }
        });
      }
      return applications;
    },
    getAlertCapabilitiesList() {
      const featureFlag =
        BuildConfig.VUE_APP_ACTIVE_CAPABILITIES ||
        process.env.VUE_APP_ACTIVE_CAPABILITIES ||
        '';
      const activeCapabilities = featureFlag.split(',');
      let alertCapabilityList = this.getAlertCapabilities;
      alertCapabilityList = alertCapabilityList
        .map((obj) => {
          if (AI_CAPABILITIES.includes(obj?.key)) {
            return {
              label: obj?.label,
              value: obj?.key,
              icon: 'starFilled',
              resourceGroup: obj?.resourceGroup,
            };
          } else {
            return {
              label: obj?.label,
              value: obj?.key,
              resourceGroup: obj?.resourceGroup,
            };
          }
        })
        .sort((a, b) => (b.icon === 'starFilled') - (a.icon === 'starFilled'));
      if (activeCapabilities.length > 0 && !activeCapabilities.includes('')) {
        alertCapabilityList = alertCapabilityList.filter((capability) => {
          const capabilityKey = capability.value.toLowerCase();
          return activeCapabilities.includes(capabilityKey);
        });
      }
      return this.setCapabilitiesPermission(alertCapabilityList);
    },
    getAlertEnabledCapabilitiesList() {
      return this.getAlertCapabilitiesList.filter(
        (capability) => capability.disabled !== true,
      );
    },
  },
  methods: {
    ...mapMutations('alertV2State/configure', [
      'setAlertCapabilities',
      'setCurrentAlertApplication',
      'setCurrentAlertCapability',
      'setIsErrorCodeEnabled',
      'setCurrentSubType',
      'setAlertApplication',
      'setServiceCurrentPage',
    ]),
    ...mapActions('alertV2State/configure', [
      'GET_ALERT_APPLICATIONS',
      'GET_METRICS_MAP',
      'reloadConfiguredAlerts',
    ]),
    ...mapActions('wsmState/detail', ['getWSMInstances']),
    ...mapActions('apmState/apmCommonState', ['getServiceLanguage']),
    async resetQuery() {
      const currentRoute = this.$route;
      await this.$router.replace({
        path: currentRoute.path,
        query: {},
      });
    },
    selectAWSCapabilityOption(item) {
      this.currentVendor = item;
    },
    async selectRDSCapabilityOption(item) {
      this.setCurrentSubType(item);
      this.currentService = item;
      this.setCurrentAlertApplication({
        key: '',
        label: '',
        permissions: [],
      });
      await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
    },
    async getMetricsByCapability() {
      if (this.getCurrentAlertCapability.key === Capability.APM) {
        await this.getServiceLanguage({
          serviceId: this.getCurrentAlertApplication?.key,
        });
      }
      await this.GET_METRICS_MAP({
        capability: AlertsV2Utils.CurrentAlertCapabilityValue(
          this.currentCapability.key,
        ),
        serviceId: this.currentApplication.key,
      });
    },
    async selectCapabilityOption(value, option) {
      const key = option.key?.split('-')?.[0];
      const capabilityDetails = { key, label: option?.label };
      this.setCurrentAlertCapability(capabilityDetails);
      if (capabilityDetails.key === 'APM') {
        this.setIsErrorCodeEnabled(true);
      } else {
        this.setIsErrorCodeEnabled(false);
      }
    },
    fetchWSMInstances(serviceId) {
      this.getWSMInstances({
        serviceId: serviceId,
        properties: [],
      });
    },
    async selectApplicationOption(value, option) {
      const applicationDetails = {
        ...option.metaProperty,
      };
      this.setCurrentAlertApplication(applicationDetails);
      if (this.searchAlertService) {
        this.searchAlertService = '';
        this.setServiceCurrentPage(1);
        this.isLoading = true;
        await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
        this.isLoading = false;
      }
    },
    filterOption(input, option) {
      return option?.label
        ? option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        : false;
    },
    getQueryParams() {
      return this.$route.query;
    },

    initializeServiceName() {
      const { capability, serviceName, serviceId } = this.getQueryParams();
      if (capability && serviceName && serviceId) {
        const mappedCapability = AlertsV2Utils.toMapCapability(
          capability.toUpperCase(),
        );
        if (mappedCapability) {
          const selectedCapability = this.getAlertCapabilitiesList.find(
            (cap) => cap.value === mappedCapability,
          );
          if (selectedCapability) {
            this.setCurrentAlertCapability({
              ...selectedCapability,
              key: selectedCapability.value,
            });

            this.setCurrentAlertApplication({
              key: serviceId,
              label: serviceName,
            });
            if (selectedCapability.value === Capability.CLOUD) {
              const subType = parseServiceObjFromApplication({
                key: serviceId,
              }).sub;
              this.setCurrentSubType(subType);
              this.currentService = RDS_ALERT_CAPABILITIES.find(
                (capability) => capability.value === this.currentSubType,
              )?.label;
            }
          }
        }
      } else if (capability) {
        const mappedCapability = AlertsV2Utils.toMapCapabilityName(capability);
        const selectedCapability = mappedCapability
          ? this.getAlertCapabilitiesList.find(
              (cap) => cap.value === mappedCapability,
            )
          : null;

        selectedCapability &&
          this.setCurrentAlertCapability({
            ...selectedCapability,
            key: selectedCapability.value,
          });
        this.setCurrentAlertApplication({
          key: '',
          label: '',
        });
        if (selectedCapability.value === Capability.CLOUD) {
          this.currentService = this.getRDSAlertCapabilitiesList[0];
          this.setCurrentSubType(RDS_ALERT_CAPABILITIES[0].value);
        }
      } else {
        this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
      }
      this.resetQuery();
    },
    getAlertServiceParams() {
      return {
        duration: this.getDurationTime,
        keyword: this.searchAlertService || '',
        pagination: {
          pageNum: this.serviceCurrentPage,
          pageSize: PAGE_SIZE_SCROLL,
          needTotal: true,
        },
        permissions: [permissionTypes.ALERT_READ, permissionTypes.ALERT_WRITE],
      };
    },
    async onOpenSelectField(open) {
      if (open && this.searchAlertService) {
        this.setServiceCurrentPage(1);
        this.searchAlertService = '';
        this.isLoading = true;
        await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
        this.isLoading = false;
      }
    },
    async scrollAlertServices() {
      this.setServiceCurrentPage(this.serviceCurrentPage + 1);
      this.isLoading = true;
      await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
      this.isLoading = false;
    },
    async onSearchAlertService(val) {
      this.setServiceCurrentPage(1);
      this.searchAlertService = val;
      this.isLoading = true;
      await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
      this.isLoading = false;
    },
    setAlertAppDefaultParams() {
      this.isLoading = true;
      this.setServiceCurrentPage(1);
      this.searchAlertService = '';
      Object.keys(this.$route?.query || {}).length === 0 &&
        this.setCurrentAlertApplication({
          key: '',
          label: '',
          permissions: [],
        });
      this.setAlertApplication([]);
    },
    setCapabilitiesPermission(alertCapabilityList) {
      const { hasCapabilityAlertPermission } = usePermissions();
      return alertCapabilityList.map((capability) => {
        const hasPermission = hasCapabilityAlertPermission(
          capability.resourceGroup,
        );
        return {
          ...capability,
          disabled: !hasPermission,
        };
      });
    },
  },
  async created() {
    !this.getCurrentAlertCapability?.key &&
      this.setCurrentAlertCapability({
        ...this.getAlertEnabledCapabilitiesList[0],
        key: this.getAlertEnabledCapabilitiesList[0].value,
      });
    if (this.getActiveCapabilities[0] !== '' && !this.setAlertActiveCapabilty) {
      this.setAlertActiveCapabilty = true;
    }
    const currentCapability = this.getCurrentAlertCapability;
    if (currentCapability.key === 'APM') {
      this.setIsErrorCodeEnabled(true);
    } else {
      this.setIsErrorCodeEnabled(false);
    }
    if (this.getActiveCapabilities[0] !== '' && !this.setAlertActiveCapabilty) {
      this.setAlertActiveCapabilty = true;
      this.setCurrentAlertCapability(this.getAlertEnabledCapabilitiesList[0]);
    }
    await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());

    this.initializeServiceName();
    this.isLoading = false;
  },
  mounted() {
    this.currentService =
      RDS_ALERT_CAPABILITIES.find(
        (capability) => capability.value === this.currentSubType,
      )?.label || RDS_ALERT_CAPABILITIES[0]?.label;
  },
  async beforeMount() {
    if (this.getCurrentAlertCapability.key === Capability.CAPABILITY_CLOUD) {
      this.setCurrentSubType(
        this.currentSubType !== ALERT_SUB_TYPES.MYSQL
          ? this.currentSubType
          : ALERT_SUB_TYPES.MYSQL,
      );
      await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
    }
  },
  watch: {
    async getCurrentAlertCapability() {
      this.setAlertAppDefaultParams();
      await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
      await this.getMetricsByCapability();
      this.reloadConfiguredAlerts(false);
      this.isLoading = false;
    },
    async getCurrentAlertApplication() {
      if (
        this.getCurrentAlertCapability &&
        this.getCurrentAlertCapability.key === CAPABILITY_WSM &&
        this.getCurrentAlertApplication &&
        this.getCurrentAlertApplication.key
      ) {
        this.fetchWSMInstances(this.getCurrentAlertApplication.key);
      }
      await this.getMetricsByCapability();
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  margin-left: 0em;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  margin-left: 0em;
  margin-top: 0.8125em;
  background-color: transparent;
  color: $font-primary;
  width: 100%;
}

.item {
  margin-right: 1.875em;
}
.dropdown-ph > .select-box {
  width: 60rem !important;
}
.capability-dropdown {
  margin-right: 10px;
}
.dropdown-alertV2 {
  width: 18.75rem !important;
}
.inner-inner-btn {
  display: inline-flexbox;
  align-items: center;
}
.showAIEnabledIcon {
  margin-right: 0em;
  @include svg-fill($color-active-blue);
  vertical-align: super;
  margin-bottom: 1em;
}
</style>
